<script type="text/babel">
import { mapMutations } from 'vuex';

export default {
    name: 'IdGetterMixin',
    methods: {
        ...mapMutations(['updateMetaData']),
        updateMetadataSource (prop, toDelete) {
            if (prop === 'background-image') {
                this.updateMetaData({
                    pathToId: this.editedElementId, toDelete: toDelete
                });
            }
        },
        sanitizePath (path) {
            return path.replace('..', '.');
        }
    }
};

</script>

